import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import Effect from '../../../domain/entities/Effect';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexEffectsSuccess: {
      const result = action.payload as PaginatedResult<Effect>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
